'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavLink = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  display: block;\n  color: #A2AAB3;\n  transition: none;\n  text-decoration: none;\n  text-transform: capitalize;\n  padding: 1em 4em;\n\n  &.active {\n    color: white;\n    background: #24A9BD;\n  }\n\n  @media ', ' {\n    padding: 0\n\n    &.active {\n      color: #42474D;\n      background: none;\n    }\n  }\n'], ['\n  display: block;\n  color: #A2AAB3;\n  transition: none;\n  text-decoration: none;\n  text-transform: capitalize;\n  padding: 1em 4em;\n\n  &.active {\n    color: white;\n    background: #24A9BD;\n  }\n\n  @media ', ' {\n    padding: 0\n\n    &.active {\n      color: #42474D;\n      background: none;\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var ReactRouter = _interopRequireWildcard(_reactRouterDom);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('./styles');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var NavLink = exports.NavLink = (0, _styledComponents2.default)(function (props) {
  return _react2.default.createElement(ReactRouter.NavLink, Object.assign({}, props, { activeClassName: 'active' }));
})(_templateObject, _styles.styles.media.laptop);
NavLink.displayName = 'NavLink';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/NavLink.js
// module id = 642
// module chunks = 0